import { Dialog } from 'components/Dialog';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import { CLEAR_ALERT } from 'store/app/actions';
import { selectAlert } from 'store/app/selectors';
import reactStringReplace from 'react-string-replace';

export const DialogAlert: React.FC = () => {
  const dispatch = useDispatch();
  const alert = useSelector(selectAlert);

  if (!alert) {
    return null;
  }

  const handleDismiss = () => {
    dispatch(CLEAR_ALERT());
    if (alert.onConfirm) {
      dispatch(alert.onConfirm);
    }
  };
  const buttons = [
    { onPress: handleDismiss, text: alert.buttonText || 'Okay' },
  ];
  let { title } = alert;
  let titleIcon: ICONS | undefined = alert.icon;

  if (alert.type === 'networkerror') {
    title = title || 'Internet Required';
    titleIcon = ICONS.CloudSlashLight;
  }

  const alertButton = alert.altButton;
  if (alertButton) {
    buttons.unshift({
      onPress: () => {
        if (alertButton.closeAlert) {
          dispatch(CLEAR_ALERT());
        }
        dispatch(alertButton.action);
      },
      text: alertButton.text,
    });
  }

  const bold = /\*(.*?)\*/gm;
  const text = (
    <Txt size="normal">
      {reactStringReplace(alert.text, bold, (match, i) => (
        <Txt key={i} size="normal" weight="bold">
          {match}
        </Txt>
      ))}
    </Txt>
  );

  return (
    <Dialog
      title={title}
      titleIcon={titleIcon}
      text={text}
      buttons={buttons}
      onDismiss={handleDismiss}
    />
  );
};
